import React from 'react';
import { injectIntl } from 'react-intl';
import ConversationsListItem from './ConversationsListItem';
import { inject, observer } from 'mobx-react';

@inject('conversationsStore')
@observer
class ConversationsList extends React.Component {
  componentDidMount() {
    const { conversationsStore } = this.props;

    conversationsStore.fetchIndex();
  }

  render() {
    const { conversationsStore } = this.props;
    const sortedConversations = conversationsStore.sortedConversations;

    return (
      <div className="conversations-list main-loader">
        {conversationsStore.loading ? (
          <div className="loader-lg" style={{ marginTop: 120 }} />
        ) : (
          <div>
            {sortedConversations.map(item => (
              <ConversationsListItem
                conversation={item}
                onItemClick={this.props.onItemClick}
                key={item.id}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(ConversationsList);
